module.exports = __webpack_public_path__ + "img/mu.cc1b9861.jpg";